import { render, staticRenderFns } from "./ageManagement.vue?vue&type=template&id=6b0e37be&scoped=true&"
import script from "./ageManagement.vue?vue&type=script&lang=js&"
export * from "./ageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e37be",
  null
  
)

export default component.exports